import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { Event } from '../types';

export type EventState = Event | null;
const initialState = null as EventState; 

export const eventSlice = createSlice({
    name: 'event',
    initialState,
    reducers: {
        eventSet: (state, action: PayloadAction<EventState>) => {
            return action.payload;
        },
    }
});

export const { eventSet } = eventSlice.actions;
export default eventSlice.reducer;
